import React from 'react'
import './PairDriftBadge.css'

interface PairDriftBadgeProps {
	isPairActive: boolean
	pairBonusScore: number
	pairStreakSec: number
}

export const PairDriftBadge: React.FC<PairDriftBadgeProps> = ({
	isPairActive,
	pairBonusScore,
	pairStreakSec,
}) => {
	if (!isPairActive && pairBonusScore === 0) return null

	return (
		<div className={`pair-drift-badge ${isPairActive ? 'pair-drift-badge--active' : 'pair-drift-badge--inactive'}`}>
			<div className="pair-drift-badge__icon">
				{/* SVG двух машин в одну сторону */}
				<svg width="20" height="14" viewBox="0 0 20 14" fill="none">
					<path d="M2 9h4M14 9h4M1 7l1-3h5l1 3M11 7l1-3h5l1 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
					<circle cx="4" cy="10.5" r="1.5" fill="currentColor" />
					<circle cx="8" cy="10.5" r="1.5" fill="currentColor" />
					<circle cx="12" cy="10.5" r="1.5" fill="currentColor" />
					<circle cx="16" cy="10.5" r="1.5" fill="currentColor" />
				</svg>
			</div>
			<div className="pair-drift-badge__content">
				{isPairActive && (
					<span className="pair-drift-badge__label pair-drift-badge__label--live">
						ПАРА {pairStreakSec > 0 ? `${pairStreakSec}с` : ''}
					</span>
				)}
				{pairBonusScore > 0 && (
					<span className="pair-drift-badge__bonus">+{pairBonusScore.toLocaleString()}</span>
				)}
			</div>
		</div>
	)
}